/* eslint-disable */
import React, { Component } from 'react';
import language from '../../../assets/languages/language';
import Loader from '../../../common/loader';
import ModalComponent from '../../Common/Modal';
import AppRoutes from '../../config/AppRoutes';
import alertMessage from '../../config/alertMessage';
import { getAllVideos } from '../services';
import VideoList from './VideoList';
export default class ESGVideos extends Component {

    constructor (props) {
        super(props);
        this.state = {
            lastAttempt: false,
            chapters: [],
            showFreePremium: true,
            videoTable: '',
            alert_status: false,
            isLoading: true,

        };
    }

    static contextTypes = {
        router: React.PropTypes.object,
    };


    toggleAlert = () => {
        this.setState({
            alert_status: !this.state.alert_status,
        });
    };

    goPremium = () => {
        this.context.router.push({
            pathname: AppRoutes.SUBSCRIBE,
        });
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getVideos();
        this.getLastVideo();
    }

    getVideos = async () => {
        try {
            const response = await getAllVideos();
            if (response.success) {
                this.setState({
                    chapters: response.data,
                    videoTable: response.videoTable,
                    showFreePremium: !Object.keys(response.userSubscriptionDetails).length,
                    isLoading: false,

                });
            }
        } catch (error) {

        }
    }

    getLastVideo() {
        try {

        } catch (error) {

        }

    }
    render() {
        const { chapters, lastAttempt, showFreePremium, videoTable, alert_status, isLoading } = this.state;
        return (

            <div className='video_lesson_wrap'>
                <div className='animated fadeIn'>
                    <div className='margin_bottom_20 d-flex justify-content-between last_question_read'>
                        <h1 className='section_head'> Video Lessons </h1>

                        {lastAttempt ? (
                            <button
                                className='btn btn-primary pointer_class'
                            // onClick={this.goToVideo.bind(this)}
                            >
                                {' '}
                                Go to my Last Viewed Video{' '}
                            </button>
                        ) : null}
                    </div>
                    <div className='row'>
                        <div className='col-xs-12 col-sm-12 col-md-12'>
                            <div className='bank_wrapper'>
                                <div className='row'>
                                    <div className='col-sm-12 col-md-12'>
                                        <div className='card' />
                                    </div>
                                    {isLoading ? <Loader /> :
                                        chapters.map((item, index) => {

                                            return <div className='col-sm-12 col-md-12' key={index}>
                                                <div className='card'>
                                                    <div className='card-header card_header_bg' value={item.id}>
                                                        <a
                                                            className='pointer_class'
                                                            id={item.name}
                                                            value={item.id}
                                                        // onClick={this._getReadings.bind(this, item, index)}
                                                        >
                                                            {language.LC().TOPIC} {index + 1} - {item.name}
                                                        </a>
                                                    </div>
                                                    <div className='card-block list_icon_outer' key={item.name}>
                                                        {item[videoTable].length > 0 ? (
                                                            <p>
                                                                {language.LC().TOTAL_VIDEOS}: {item[videoTable].length}
                                                            </p>
                                                        ) : (
                                                            <p />
                                                        )}
                                                        <div key={index} className='col-xs-12 col-sm-12 col-md-12'>
                                                            <VideoList
                                                                key={item.id}
                                                                videos={item[videoTable]}
                                                                showFreePremium={showFreePremium}
                                                                gotoVideo={(index, video) => {
                                                                    if (showFreePremium && !video.free) return this.toggleAlert();
                                                                    this.context.router.push({
                                                                        pathname: AppRoutes.ESG_VIDEO_LESSON.replace(':chapter', item.id).replace(':index', index)
                                                                    });
                                                                }
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>;
                                        }
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <ModalComponent
                        goPremium={this.goPremium}
                        toggleAlert={this.toggleAlert}
                        alert_status={alert_status}
                        MessageContent={alertMessage.messageContent_ESG}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/ESG/Videos/index.jsx